import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

// COMPONENTES PÚBLICOS
import { HomeComponent } from './home/home.component';
import { MateriaComponent } from './materia/materia.component';
import { ArtigosComponent } from './artigos/artigos.component';
import { ArtigosPorDataComponent } from './artigos-por-data/artigos-por-data.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { ContatoComponent } from './contato/contato.component';
import { VoleiProtocolComponent } from './volei-protocol/volei-protocol.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MateriaComentarioComponent } from './materia-comentario/materia-comentario.component';
import { MateriaComentarioRespostaComponent } from './materia-comentario-resposta/materia-comentario-resposta.component';
import { ListMateriaDatasComponent } from './list-materia-datas/list-materia-datas.component';
import { LinkComponent } from './link/link.component';
import { CinemaComponent } from './cinema/cinema.component';
import { StarRatingComponent } from '../shared/components/star-rating/star-rating.component';

@NgModule({
  declarations: [
    HomeComponent,
    LinkComponent,
    MateriaComponent,
    MateriaComentarioComponent,
    MateriaComentarioRespostaComponent,
    ListMateriaDatasComponent,
    ArtigosComponent,
    ArtigosPorDataComponent,
    PesquisaComponent,
    ContatoComponent,
    VoleiProtocolComponent,
    CinemaComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    StarRatingComponent,
    RouterModule.forChild([
      { path: '', component: HomeComponent },
      { path: 'home', component: HomeComponent },
      { path: 'link', component: LinkComponent },
      { path: 'materia/:id', component: MateriaComponent },
      { path: 'artigos/:id', component: ArtigosComponent },
      {
        path: 'artigos-por-data/:ano/:mes/:temaId',
        component: ArtigosPorDataComponent
      },
      { path: 'pesquisa/:termoPesquisa', component: PesquisaComponent },
      { path: 'cinema', component: CinemaComponent },
      { path: 'volei-protocol', component: VoleiProtocolComponent },
      { path: 'contato', component: ContatoComponent }
    ])
  ]
})
export class PublicModule { }
